module.exports = __webpack_public_path__ + "img/sld_aux.f699f7f4.svg";